// extracted by mini-css-extract-plugin
export default {"signatureField":"cx4S3q","header":"AdXaNW","inputContainer":"P8_GBE"};